<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >DINE IN MANAGEMENT</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <div v-for="item in filterNogroupItem" :key="item.title">
          <v-list-tile :to="item.url">
            <v-list-tile-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <div v-for="subItem in filterSubSidebar(item)" :key="subItem.title">
            <v-list-tile :to="subItem.url">
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  v-if="subItem.check == 'on_process'"
                  fab
                  color="primary"
                  style="height: 28px; width: 28px"
                  class="black--text"
                  >{{ orderListOnProcess.length }}</v-btn
                >
              </v-list-tile-action>
            </v-list-tile>
            <hr v-if="subItem.no_filter_date == true" />
          </div>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      itemNoGroup: [
        {
          active: true,
          action: "list_alt",
          permission_name: "order_list",
          title: "Order Dine in",
          url: "/weserve_admin_login/-/maindinein/order/",
        },
      ],
      items: [
        {
          action: "store",
          permission_name: "manage_list",
          title: "Store&Product Management",
          items: [
            {
              title: "Store Management",
              permission_name: "store_manage",
              url: "/weserve_admin_login/-/maindinein/storemanage",
            },
            {
              title: "Store Type Management",
              permission_name: "store_type_manage",
              url: "/weserve_admin_login/-/maindinein/storetypemanage",
            },
            {
              title: "Store Category Management",
              permission_name: "store_category_manage",
              url: "/weserve_admin_login/-/maindinein/store-category-management",
            },
          ],
        },
        {
          action: "edit",
          permission_name: "create_list",
          title: "Form Create",
          items: [
            {
              title: "Store",
              permission_name: "create_store",
              url: "/weserve_admin_login/-/maindinein/createstore",
            },
            {
              title: "Store Type",
              permission_name: "create_store_type",
              url: "/weserve_admin_login/-/maindinein/createstoretype",
            },
          ],
        },
        {
          action: "star",
          permission_name: "review_list",
          title: "Review",
          items: [
            {
              title: "Review List",
              permission_name: "store_review_manage",
              url: "/weserve_admin_login/-/maindinein/store-review-management",
            },

            {
              title: "Campaign Review Benefit",
              permission_name: "review_benefit",
              url: "/weserve_admin_login/-/maindinein/dinein-review-benefit",
            },
          ],
        },
        {
          action: "mdi-cogs",
          permission_name: "setting_list",
          title: "Setting",
          items: [
            {
              title: "District Info",
              permission_name: "district_setting",
              url: "/weserve_admin_login/-/maindinein/setting/district",
            },
          ],
        },
      ],
      intervalCountOrder: null,
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
      orderListOnProcess: (state) => state.fetchDineIn.orderListOnProcess,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.main_menu.dine_in_management) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
    filterNogroupItem() {
      return this.itemNoGroup.filter((val) => {
        for (let val2 in this.permission.main_menu.dine_in_management) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
  methods: {
    ...mapActions({
      // fetchOrderList: "fetchDineIn/fetchOrderList",
    }),
    filterSubSidebar(item) {
      return item.items.filter((val) => {
        for (let val2 in this.permission.main_menu.dine_in_management[
          item.permission_name
        ]) {
          if (val2 == val.permission_name) return val;
        }
      });
    },

    // async fetchOrderOnProcess() {
    //   return this.fetchOrderList({
    //     order_status: [1],
    //   });
    // },
    // async getData() {
    //   await this.fetchOrderOnProcess();
    //   let vm = this;
    //   this.intervalCountOrder = setInterval(async function() {
    //     vm.fetchOrderOnProcess();
    //   }, 60000);
    // },
  },
  beforeDestroy() {
    // clearInterval(this.intervalCountOrder);
  },
  mounted() {
    // this.getData();
  },
};
</script>
